module.exports = __webpack_public_path__ + "static/media/si_logo.570d7793.png";